import React from 'react'
import { Box, Button, Flex, Heading, Message, Modal, Text } from '@workwhile/ui'
import { useCompaniesQuery } from 'queries/companies'
import { useDeleteTimeClockFlowContextValue } from '../context/DeleteTimeClockFlowProvider'
import { useTimeClocksWorkflowsContextValue } from '../../../context/TimeClocksWorkflowsProvider'
import { useTimeClocksContextValue } from '../../../context/TimeClocksProvider'
import { TimeClock } from '../../../types'

export const DeleteTimeClockFlowMain = ({
  timeClock,
}: {
  timeClock: TimeClock
}) => {
  const {
    deleteTimeClockFlow: { isOpen, close },
  } = useTimeClocksWorkflowsContextValue()

  const {
    state: { isPending, errorMessage },
    actions: { confirm, reset },
  } = useDeleteTimeClockFlowContextValue()

  const {
    state: { locations },
  } = useTimeClocksContextValue()

  const { data: companies } = useCompaniesQuery()

  const company = companies?.find(
    (candidate) => candidate.id === timeClock.companyId
  )
  const companyLabel = company
    ? `${company.name} (${company.id})`
    : String(timeClock.companyId)

  const location = locations?.find(
    (candidate) => Number(candidate.id) === timeClock.locationId
  )
  const locationLabel = location
    ? `${location.name} (${timeClock.locationId})`
    : String(timeClock.locationId)

  const handleClose = () => {
    reset()
    close()
  }

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      position="top"
      loading={isPending}
      customCta={
        <Flex>
          <Button variant="text" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={confirm}>
            Deregister
          </Button>
        </Flex>
      }
    >
      <Heading level={3} fontWeight="400" style={{ margin: 0 }}>
        Deregister clock
      </Heading>
      <Box mt={4}>Vendor Clock ID</Box>
      <Box color="lightText">{timeClock.vendorClockId}</Box>
      <Box mt={4}>Company</Box>
      <Box color="lightText">{companyLabel}</Box>
      <Box mt={4}>Location</Box>
      <Box color="lightText">{locationLabel}</Box>
      <Text mt={3} style={{ paddingTop: 20 }}>
        <strong style={{ fontSize: '1.75rem' }}>
          Are you sure you want to deregister this clock?
        </strong>
        <ul style={{ listStyleType: 'disc', paddingLeft: 20, paddingTop: 15 }}>
          <li>This clock will be soft-deleted, not permanently removed.</li>
          <li>
            Punches from this clock will no longer match until it's
            re-registered.
          </li>
        </ul>
      </Text>

      {errorMessage ? (
        <Message variant="error" mt={3} borderRadius="small">
          {errorMessage}
        </Message>
      ) : null}
    </Modal>
  )
}
